import { Box } from '@material-ui/core';

import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { Font } from '@/components/shared/components/Font';
import { IconButton } from '@/components/shared/components/IconButton';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface PaginatedListWrapperProps {
  page: number;
  rowsPerPage: number;
  totalElementsValue: number;
  onNext: () => void;
  onPrev: () => void;
  disableNext: boolean;
  disablePrev: boolean;
  children: React.ReactElement;
  boxProps?: React.ComponentProps<typeof Box>;
}

export const PaginatedListWrapper = ({
  page,
  rowsPerPage,
  totalElementsValue,
  onNext,
  onPrev,
  disableNext,
  disablePrev,
  children,
  boxProps,
}: PaginatedListWrapperProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const { getTextIdTranslation } = useTranslation();
  return (
    <Box
      p={2}
      bgcolor={palette.grey[50]}
      borderRadius={customBorderRadius.paper}
      height={'436px'}
      position={'relative'}
      overflow={'hidden'}
      {...boxProps}
    >
      <Box position={'relative'} height={'100%'}>
        {children}
      </Box>
      <Box className={'channels-pagination'} px={1} style={{ paddingBottom: 16 }}>
        <Box mr={1}>
          <Font variant="caption" style={{ color: palette.grey[400] }}>
            {`${(page - 1) * rowsPerPage + 1}-${
              page * rowsPerPage > totalElementsValue ? totalElementsValue : page * rowsPerPage
            } ${getTextIdTranslation('OF')} ${totalElementsValue}`}
          </Font>
        </Box>
        <IconButton icon="chevron_left" size="small" onClick={onPrev} disabled={disablePrev} />
        <IconButton icon="chevron_right" size="small" onClick={onNext} disabled={disableNext} />
      </Box>
    </Box>
  );
};
